module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bm-b04bb306c0c8f2e752d95340812f3692.svg";